import {useParams, useRouteMatch} from 'react-router-dom';
import {ExternalAccountDetails} from '../../../../../../../components/external-account-details/external-account-details';
import {ExternalAccountType} from '../../../../../../../backend/enums/external-account-type';

export default function SeniorExternalAccountSystemAdministratorOfficeScreen() {
  // Get params
  let {id, type}: {id?: string; type?: string} = useParams();

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <ExternalAccountDetails
      userId={id || ''}
      type={(type as ExternalAccountType) || ExternalAccountType.Call}
      redirectUrl={`${url.replace(`/${type}`, '')}`}
    />
  );
}
